import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, Link } from "react-router-dom";
import './App.css';
import { apiPost } from "./api";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoute";

// Auth (public)
import SignIn from "./pages/auth/react/SignIn";
import Register from "./pages/auth/react/Register";
import Verified from "./pages/auth/react/Verified";
import ForgotPassword from "./pages/auth/react/ForgotPassword";
import ResetPassword from "./pages/auth/react/ResetPassword";
import ResendVerification from "./pages/auth/react/ResendVerification";
import LandingLayout from "./LandingLayout";

// App (protected)
import Home from "./pages/app/react/Home";
import AccountSettings from "./pages/app/react/AccountSettings";
import MySchedule from "./pages/app/react/MySchedule";
import ManualEntry from "./pages/app/react/SelectCourses";
import FindClassmates from "./pages/app/react/FindClassmates";
import Inbox from "./pages/app/react/Inbox";
import MyFriends from "./pages/app/react/MyFriends";

function AppRoutes() {
  const nav = useNavigate();

  useEffect(() => {
    const publicRoots = ["/", "/auth/react"];
    if (publicRoots.some(path => window.location.pathname.startsWith(path))) {
      return;
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) return;

    const refreshToken = sessionStorage.getItem("refreshToken");
    if (refreshToken) {
      apiPost("/auth/refresh", { refreshToken })
        .then((res) => {
          localStorage.setItem("accessToken", res.accessToken);
          nav("/app/react/home", { replace: true });
        })
        .catch(() => nav("/auth/react/signin", { replace: true }));
    } else {
      nav("/auth/react/signin", { replace: true });
    }
  }, [nav]);

  return (
    <Routes>
      {/* Public layout */}
      <Route path="/" element={<LandingLayout />}>
        <Route index element={
          <>
            {/* White card */}
            <div className="landing-home auth-card">
              <h2>Welcome to ShareMySchedule!</h2>
              <p>Helping students connect with classmates in the same courses.</p>
              <p>Create your schedule, find classmates, and share your social links easily.</p>
              <p>Currently exclusive for York University.</p>
            </div>

            {/* Buttons outside card */}
            <div className="landing-buttons">
              <Link to="/auth/react/signin" className="primary-btn">Sign In</Link>
              <Link to="/auth/react/register" className="primary-btn">Register</Link>
            </div>
          </>
        } />
      </Route>

      <Route path="/auth/react" element={<LandingLayout />}>
        <Route path="signin" element={<SignIn />} />
        <Route path="register" element={<Register />} />
        <Route path="verified" element={<Verified />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="resend-verification" element={<ResendVerification />} />
      </Route>

      {/* Protected layout */}
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/app/react/home" element={<Home />} />
        <Route path="/app/react/my-schedule" element={<MySchedule />} />
        <Route path="/app/react/find-classmates" element={<FindClassmates />} />
        <Route path="/app/react/account-settings" element={<AccountSettings />} />
        <Route path="/app/react/inbox" element={<Inbox />} />
        <Route path="/app/react/my-friends" element={<MyFriends />} />
        <Route path="/app/react/select-courses" element={<ManualEntry />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AppRoutes />;
}
